import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, openModal } from 'redux/actions/actions';
import { RootState } from 'redux/reducers/type';

function useModal() {
  const { isOpen, body } = useSelector((state: RootState) => state.modal);

  const dispatch = useDispatch();

  const onOpenModal = useCallback(
    (body: JSX.Element) => {
      dispatch(openModal({ body }));
    },
    [dispatch],
  );

  const onCloseModal = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  return {
    isOpen,
    body,
    onOpenModal,
    onCloseModal,
  };
}

export default useModal;
